import axios from "axios";
// import useUserStore from "@/stores/useUserStore";

const BASE_URL = import.meta.env.PROD ? import.meta.env.VITE_API_URL || "https://task-fusion-server-xv6n4.ondigitalocean.app/" : "http://localhost:8080";
console.log('BASE_URL', BASE_URL);
console.log('API_URL', import.meta.env.VITE_API_URL);
export default axios.create({
  baseURL: BASE_URL,
})

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true

});

export class InsufficientScopesError extends Error {
  userId: string;
  originalError: any;
  
  constructor(message: string, userId: string, originalError?: any) {
    super(message);
    this.name = 'InsufficientScopesError';
    this.userId = userId;
    this.originalError = originalError;
  }
}

axiosPrivate.interceptors.response.use(
  response => response,
  async (error) => {
    // Check for insufficient scopes error
    if (error.response?.status === 403 && error.response?.data?.error === 'INSUFFICIENT_SCOPES') {
      const userId = error.response.data.userId || '';
      throw new InsufficientScopesError(
        error.response.data.message || 'Insufficient scopes',
        userId,
        error
      );
    }
    return Promise.reject(error);
  }
);

// axiosPrivate.interceptors.request.use(
//   config => {
//       if (!config.headers['Authorization']) {
//           const accessToken = useUserStore.getState().accessToken;
//           config.headers['Authorization'] = `Bearer ${accessToken}`;
//       }
//       return config;
//   }, (error) => Promise.reject(error)
// );

// axiosPrivate.interceptors.response.use(
//   response => response,
//   async (error) => {
//       const prevRequest = error?.config;
//       if (error?.response?.status !== 200 && !prevRequest?.sent) { // TODO change to check 403
//           prevRequest.sent = true;
//           const response = await axios.get("/refresh", { withCredentials: true });
//           prevRequest.headers['Authorization'] = `Bearer ${response.data.accessToken}`;
//           const user = useUserStore.getState().user;
//           if (user) {
//             useUserStore.getState().setAccessToken(response.data.accessToken)
//             useUserStore.getState().setUser({ ...user, accessToken: response.data.accessToken })
//           }
//           return axiosPrivate(prevRequest);
//       }
//       return Promise.reject(error);
//   }
// );

